import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/omnitecActions'
// import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchOmnitecOrganizations = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.OMNITEC_ORGANIZATIONS_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.omnitecOrganizationsFind, params), auth, { method: 'GET' })
    // fetch(urlParams(urls.omnitecOrganizationsFind, params), { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_fetchOrganizationsSuccess(json)))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_fetchOrganizationsFailure,
                'Что-то пошло не так!',
                'При получении организаций произошла ошибка'
            )
        )
}

/** @thunk **/
export const postOmnitecOrganization = organization => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(organization)
    }
    const { auth } = getState()

    // fetch(urls.omnitecOrganizations, opts)
        securedFetch(urls.omnitecOrganizations, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_saveOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация добавлена'))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_saveOrganizationsFailure,
                'Что-то пошло не так!',
                'При сохранении организации произошла ошибка'
            )
        )
}

/** @thunk **/
export const updateOmnitecOrganization = payload => (dispatch, getState) => {
    // prettier-ignore
    const { omnitecOrganizations: { entities: { organizations } } } = getState()
    const { auth } = getState()

    const { ourId } = payload

    const currentOrganization = organizations.find(item => item.ourId === ourId)

    if (!payload.username) delete payload.username

    const body = { ...currentOrganization, ...payload }

    if (body.ourId) delete body.ourId

    const opts = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    }

    securedFetch(urls.omnitecOrganizationUpdate(ourId), auth, opts)
    // fetch(urls.omnitecOrganizationUpdate(ourId), opts)
        .then(handleResponse)
        .then(json => dispatch(actions.omnitec_updateOrganizationsSuccess(json)))
        .then(() => toastr.success('Организация обновлена'))
        .catch(
            handleError(
                dispatch,
                actions.omnitec_updateOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}

export const deleteOmnitecOrganization = ourId => (dispatch, getState) => {
    // prettier-ignore
    const { auth, omnitecCurrentOrganization } = getState()

    const canUseCurrentOrganization = omnitecCurrentOrganization !== ourId

    const opts = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' }
    }

    securedFetch(urls.omnitecOrganizationDelete(ourId), auth, opts)
    // fetch(urls.omnitecOrganizationDelete(ourId), opts)
        .then(handleResponse)
        .then(json => {
            if (!canUseCurrentOrganization) {
                dispatch({
                    type: ActionTypes.OMNITEC_CURRENT_ORGANIZATION_CHANGE,
                    data: null
                })
            }
            return dispatch(actions.omnitec_deleteOrganizationsSuccess(ourId))
        })
        .catch(
            handleError(
                dispatch,
                actions.omnitec_deleteOrganizationsFailure,
                'Что-то пошло не так!',
                'При обновлении организации произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/omnitecApi/omnitecOrganizations.js